import React from 'react';
import AttributeSelect from './AttributeSelect';

interface Props {
  value: string | '';
  onChange: (id: string | '') => void;
  label?: string;
  className?: string;
}

const RoleSelect: React.FC<Props> = ({ value, onChange, label = 'Role', className }) => (
  <AttributeSelect kind="roles" label={label} value={value} onChange={onChange} className={className} />
);

export default RoleSelect;
